import React from 'react';
import { withUserContext } from '../../../contexts/UserContext';
import TableComponent from '../../SharedComponents/Table';
import { handlePaginationList } from '../../../Common/TableHelper';
import MainViewModalComponent from "../../../Common/MainViewModalLayout/Modal/Modal";
import { MDBCol, MDBRow, MDBIcon } from 'mdbreact';
import {validateDuration, validateNumbersOnly} from '../../../Common/Helper'
import { payeeDetails } from '../EditPayee/config';
import Popover from '@material-ui/core/Popover';

const EMPTY_ERRORS = { cue_no: false, composition: false, how_used: false, min: false, sec: false };

export default withUserContext(class CuesheetTableComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renderList: JSON.parse(JSON.stringify(this.props?.renderList || [])),
            composerName: {},
            publisherName: {},
            compositionName: {},
            errorFields: { ...EMPTY_ERRORS },
            newItemErrors: { ...EMPTY_ERRORS },
            mode: null,
            nodeName: null,
            cueSheetItemIndex: null,
            showComposerModal: this.props?.showTableComposerModal,
            showPublisherModal: this.props?.showTablePublisherModal,
            openConfirmModal: false,
            openInlineDeleteModal: false,
            selectedCueSheetRecordId: null,
            warningModal: { anchorEl: null, title: '', messages: [], type: 'WARNING' },
            addedPublisherInfo: {},
            isDurationValid: false,

        }
    };


    // componentDidUpdate = (prevProps, prevState) => {
    //     if (JSON.stringify(prevState.renderList) !== JSON.stringify(this.props.renderList)) {
    //         this.setState({
    //             renderList: JSON.parse(JSON.stringify(this.props?.renderList || [])),
    //         });
    //     }
    // }



    handleAddNewItem = (newDataItem) => {
        let payload = { ...this.props?.formatCueSheetDetails(newDataItem) };
        this.setState({ newItemErrors: { ...EMPTY_ERRORS }, isDurationValid: false}, () => {
            if(payload?.cue_no && payload?.composition && payload?.how_used && (Number(payload?.min || 0) > 0 || Number(payload?.sec || 0) > 0)
            &&(payload?.min ? validateNumbersOnly(payload?.min) && payload.min >= 0: true)
             && (payload?.sec ?  validateNumbersOnly(payload?.sec)  && payload.sec < 60 && payload.sec >= 0:true)) {
                    this.props?.postCueSheetDetails(payload, 'newItemPost')
                    this.setState({
                    composerName: {},
                    publisherName: {},
                    compositionName: {},
                    newItemErrors: { ...EMPTY_ERRORS }
                    })
            } else {
                this.setState({
                newItemErrors: {
                    cue_no: !payload?.cue_no,
                    composition: !payload?.composition,
                    how_used: !payload?.how_used,
                    min: !(Number(payload?.min || 0) > 0 || Number(payload?.sec || 0) > 0),
                    sec: !(Number(payload?.min || 0) > 0 || Number(payload?.sec || 0) > 0) 
                }
            })
            }
        })
    }

    handleInlineEdits = (id, dataItem) => {
        this.props?.editClicked(id);
         this.setState({ errorFields: { ...EMPTY_ERRORS }, newItemErrors: { ...EMPTY_ERRORS } });
        // let cueSheetDetails = [...this.state.renderList]
        // this.setState({
        //     renderList: cueSheetDetails.map((item) => {
        //         if (item.cue_sheet_record_id == id) {
        //             item['editing'] = true
        //         } else {
        //             item.editing = false
        //         }
        //         return item
        //     })
        // })
    }

    saveInlineEdits = (list, index, id, dataItem) => {
        let cueSheetDetails = [...list];
        let payload = { ...this.props?.formatCueSheetDetails(cueSheetDetails[index]) };
        this.setState({ errorFields: { ...EMPTY_ERRORS } })
        if (cueSheetDetails[index]?.cue_no && cueSheetDetails[index]?.composition &&cueSheetDetails[index]?.how_used &&  (Number(cueSheetDetails[index]?.min || 0) > 0 || Number(cueSheetDetails[index]?.sec || 0) > 0) && (cueSheetDetails[index]?.min ? validateNumbersOnly(cueSheetDetails[index]?.min) && cueSheetDetails[index]?.min >= 0: true) &&
         (cueSheetDetails[index]?.sec ?  validateNumbersOnly(cueSheetDetails[index]?.sec) && cueSheetDetails[index]?.sec < 60 && cueSheetDetails[index]?.sec >= 0:true)){
            this.props?.postCueSheetDetails(payload, cueSheetDetails[index]?.cue_sheet_record_id)
        } else this.setState({
                    errorFields: {
                        cue_no: !payload?.cue_no,
                        composition: !payload?.composition,
                        how_used: !payload?.how_used,
                        min: !(Number(cueSheetDetails[index]?.min || 0) > 0 || Number(cueSheetDetails[index]?.sec || 0) > 0),
                        sec: !(Number(cueSheetDetails[index]?.min || 0) > 0 || Number(cueSheetDetails[index]?.sec || 0) > 0)     
        }
            })

    }
    handleWarningIconClick = (dataItem, e) => {
        this.setState({
            warningModal: {
                anchorEl: e.currentTarget,
                title: dataItem.rc_icon_type === 'ERROR' ? 'Errors' : 'Warnings',
                type: dataItem.rc_icon_type || 'WARNING',
                messages: (dataItem.rc_icon_type_msg || '').split('; ').filter(Boolean)
            }
        });
    }

    openDeleteModal = (id) => {
    this.setState({openInlineDeleteModal: true, selectedCueSheetRecordId: id})}
    
    onConfirmDelete = () => {
        const { selectedCueSheetRecordId } = this.state;
        this.handleInlineDelete(selectedCueSheetRecordId);
        this.setState({ openInlineDeleteModal: false });
    };

    handleInlineDelete = (id) => {
        let cueSheetDetails = this.props?.renderList;
        let deletedItem = cueSheetDetails?.find(item => item?.cue_sheet_record_id === id);
        let payload = this.props?.formatCueSheetDetails(deletedItem, "delete");
        this.props?.postCueSheetDetails(payload, payload.cue_sheet_record_id);
        this.setState({ renderList: cueSheetDetails })
    }

    handleInlineCopy = (id) => {
        let cueSheetDetails = [...this.state?.renderList];
        let copiedItem = cueSheetDetails?.find(item => item?.cue_sheet_record_id === id);
        copiedItem.how_used = copiedItem.how_used?.value ? copiedItem.how_used?.value : copiedItem.how_used 
        let payload = { ...this.props?.formatCueSheetDetails(copiedItem, "copy") };
        this.props?.postCueSheetDetails(payload, id);
    }

    handleReadCallback = (index) => {
        this.props?.handleReadCallback(index, this.state.render)
        this.setState({ errorFields: { ...EMPTY_ERRORS } , newItemErrors: { ...EMPTY_ERRORS } });
    }

    // existingInfoUpdate = (list, index, node) => {
    //     list[index][node] = list[index][node]
    //     this.setState({ renderList: list });
    // }

    handleInlineIconClick = (nodeName, index, list) => {
        this.props?.handleInlineIconClick(nodeName, index, list, "Cuesheet Table");
    }


    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
            renderList: handlePaginationList(0, parseInt(event.target.value, 10), this.state.currentList)
        });
    }

    handleSelectCheck = (value) => {
        let list = [...this.state.renderList]
        this.setState({
            renderList: list?.map(item => {
                let newItem = { ...item }
                newItem.check = value
                return newItem
            })
        })
    }

    onConfirm = () => {
        this.handleCopyDelete('delete')
        this.setState({openConfirmModal: false})
    }

    handleCopyDelete = (type) => {
        let payload = { ...this.props?.formatCueSheetDetails(null, null) };
        if (type === 'copy') {
            payload.is_multiple_copy = 1
        } else {
            payload.is_multiple_delete = 1
        }
        payload.multiple_ids = ''
        for (let i = 0; i < this.state.renderList?.length; i++) {
            if (this.state.renderList[i]?.check) {
                payload.multiple_ids = payload.multiple_ids + this.state.renderList[i]?.cue_sheet_record_id + ','
            }
        }
        payload.multiple_ids = payload.multiple_ids.slice(0, -1);
        this.props?.postCueSheetDetails(payload, 'newItemPost');
    }

    updateRenderList = (value) => {
        let renderList = this.state.renderList
        renderList[this.state.cueSheetItemIndex].composer = value
        this.setState({ renderList: renderList });
    }
    render() {
        const errorMessages = [];
        const { errorFields , newItemErrors} = this.state;
        if (errorFields.cue_no || newItemErrors.cue_no) errorMessages.push('Cue no');
        if (errorFields.composition || newItemErrors.composition) errorMessages.push('Composition');
        if (errorFields.how_used || newItemErrors.how_used) errorMessages.push('How Used');
        if (errorFields.min || errorFields.sec || newItemErrors.min || newItemErrors.sec) errorMessages.push('Min or Sec');
        const errorMessage = errorMessages.length > 0 ? `Please enter ${errorMessages.join(', ')}` : '';

        return (
            <>
                {this.state.renderList?.length > 0 && this.props?.addItemToList  && <MDBRow className='mt-2'>
                    <MDBCol md={2}>
                        <span  className="label-with-cursor" onClick={() => { this.handleSelectCheck(true) }}>Select All</span>
                    </MDBCol>
                    <MDBCol md={2}>
                        <span  className="label-with-cursor" onClick={() => { this.handleSelectCheck(false) }}>Deselect All</span>
                    </MDBCol>
                    {this.state.renderList?.some(item => item?.check) &&<MDBCol md={2}>
                        <span className="label-with-cursor" onClick={() => { this.handleCopyDelete('copy') }}>Copy Selected Items</span>
                    </MDBCol>}
                    {this.state.renderList?.some(item => item?.check) &&<MDBCol md={2}>
                        <span className="label-with-cursor-red"onClick={() => this.setState({openConfirmModal : true}) }>Delete Selected Items</span>
                    </MDBCol>}
                    {this.state.openConfirmModal && 
                    <MessageModal
                        style={{ width: '440px'}}
                        open={this.state.openConfirmModal || false}
                        title={"Delete CueSheet"}
                        message={`Do you want to delete the selected cue(s)?`}
                        hideCancel={false}
                        primaryButtonText={"OK"}
                        secondaryButtonText={"Cancel"}
                        onConfirm={() => this.onConfirm()}
                        handleClose={() =>this.setState({openConfirmModal: false})} />}
                </MDBRow>}
                
                    {this.state.openInlineDeleteModal &&
                    <MessageModal
                        style={{ width: '420px'}}
                        open={this.state.openInlineDeleteModal || false}
                        title={"Delete CueSheet"}
                        message={`Do you want to delete the selected cue ?`}
                        hideCancel={false}
                        primaryButtonText={"OK"}
                        secondaryButtonText={"Cancel"}
                        onConfirm={this.onConfirmDelete}
                        handleClose={() =>this.setState({openInlineDeleteModal: false})} />}

                <div className="cueSheet row" id='mainGrid'>
                    <p className="f-color">{errorMessage}</p>
                    {this.props?.config?.headings[6]?.selectOptions?.length > 0  &&
                        <TableComponent
                            list={this.props.renderList || []}
                            className={"clearencRecord"}
                            stickyHeader={true}
                            inlineEditErrors={this.state.errorFields}
                            inlineNewItemErrors={this.state.newItemErrors}
                            isCuesheet={true}
                            config={this.props?.config}
                            handleAddNewItem={this.handleAddNewItem.bind(this)}
                            editCallback={this.handleInlineEdits.bind(this)}
                            saveCallback={this.saveInlineEdits.bind(this)}
                            handleDelCallBack={this.openDeleteModal.bind(this)}
                            handleInlineCopy={this.handleInlineCopy.bind(this)}
                            readCallback={this.handleReadCallback.bind(this)}
                            inlineIconClick={this.handleInlineIconClick.bind(this)}
                            handleWarningIconClick={this.handleWarningIconClick}
                            arrayCheckUncheck={(value, dataItem) => {
                                let list = [...this.state.renderList]
                                this.setState({
                                    renderList: list?.map(item => {
                                        let newItem = { ...item }
                                        if (newItem?.cue_sheet_record_id === dataItem?.cue_sheet_record_id) {
                                            newItem.check = value
                                        }
                                        return newItem
                                    })
                                })
                            }}
                            addItemToList={this.props?.addItemToList}
                            showClear={true}
                            postInitiated={this.props.isSubmit}
                            updatedItemNodeValue={this.state.nodeName === "composition" ? this.state.compositionName : this.state.nodeName === "composer" && this.state.composerName?.value?.trim()?.length !== 0 ?
                                this.state.composerName : this.state.publisherName
                            }
                            defaultValuePopulation={this.props?.currentUser || null}
                            validateNewItem={(newDataItem) => {
                                let payload = this.props?.formatCueSheetDetails(newDataItem);
                                // if (payload.cue_no != null && payload.min != null && payload.sec !==null && payload.sec < 60)
                               if (payload?.cue_no && payload?.composition && payload?.how_used && (Number(payload?.min || 0) > 0 || Number(payload?.sec || 0) > 0) && 
                                  (payload?.min ? validateNumbersOnly(payload?.min) && payload.min >= 0 : true)
                                   && (payload?.sec ?  validateNumbersOnly(payload?.sec)  && payload.sec < 60 && payload.sec >= 0:true)) {
                                    this.setState({ newItemErrors: { ...EMPTY_ERRORS }})
                                    return true
                                    
                                } else {
                                     this.setState({
                                        newItemErrors: {
                                            cue_no: !payload?.cue_no,
                                            composition: !payload?.composition,
                                            how_used: !payload?.how_used,
                                            min: !(Number(payload?.min || 0) > 0 || Number(payload?.sec || 0) > 0),
                                            sec: !(Number(payload?.min || 0) > 0 || Number(payload?.sec || 0) > 0)
                                        }
                                    });
                                }
                            }}
                            composerInfoUpdate={(value) => {
                                if (value && Object.keys(value).length === 0) {
                                    this.setState({  newItemErrors: { ...EMPTY_ERRORS }, errorFields: { ...EMPTY_ERRORS }, });
                                }  this.props?.composerInfoUpdate?.(value);
                            }}
                            fromComponent={this.props?.fromComponent ? this.props?.fromComponent : "CuesheetTable"}
                            existingInfoUpdate = {this.props?.existingInfoUpdate}

                            // setStateByChild={this.props?.setStateByChild.bind(this)}
                        />
                    }
                    {this.props.showComposerModal &&
                        <MainViewModalComponent
                            open={this.props.showComposerModal}
                            handleClose={() => this.props?.handleCueModalClose("Composer")}
                            headerText={"Composer"}
                            mode={this.state.mode}
                            modalName={"Add Composer"}
                            handleNodeValue={() => this.props?.handleTableNodeValue}
                            selectedComposerInfo = {this.props?.selectedComposerInfo}
                            updateRenderList= {this.updateRenderList.bind(this)}
                            
                        />
                    }
                    {this.props.showPublisherModal &&
                        <MainViewModalComponent
                            open={this.props.showPublisherModal}
                            handleClose={() => this.props?.handleCueModalClose("Publisher")}
                            headerText={"Publisher"}
                            mode={this.state.mode}
                            modalName={"Add Publisher"}
                            handleNodeValue={(value) => this.setState({
                                publisherName: {
                                    value: value,
                                    node: this.state.nodeName,
                                    index: this.state.cueSheetItemIndex
                                }
                            })}
                            newPublisher = {this.props?.selectedPublisherInfo}
                        />
                    }
                </div>
                <Popover
                    open={Boolean(this.state.warningModal.anchorEl)}
                    anchorEl={this.state.warningModal.anchorEl}
                    onClose={() => this.setState({ warningModal: { anchorEl: null, title: '', messages: [], type: 'WARNING' } })}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    className="flag-popover"
                    PaperProps={{ style: { backgroundColor: '#F2F2F2', fontSize: '0.65rem', fontWeight: 350, borderRadius: '1px', padding: '6px 10px', minWidth: 220, maxWidth: 460 } }}
                >
                    {(() => {
                        const isError = this.state.warningModal.type === 'ERROR';
                        const titleColor = isError ? '#c62828' : '#E65100';
                        return (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                                    <span style={{ fontWeight: 700, fontSize: '0.75rem', color: titleColor }}>{this.state.warningModal.title}</span>
                                    <MDBIcon
                                        icon="times"
                                        style={{ cursor: 'pointer', fontSize: '0.7rem', marginLeft: 12 }}
                                        onClick={() => this.setState({ warningModal: { anchorEl: null, title: '', messages: [], type: 'WARNING' } })}
                                    />
                                </div>
                                <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                    {this.state.warningModal.messages.map((msg, i) => {
                                        const match = msg.match(/^(\[[^\]]+\])\s*(.*)/s);
                                        const prefix = match ? match[1] : null;
                                        const desc = match ? match[2] : msg;
                                        return (
                                            <div key={i} className="popover-content-value" style={{ cursor: 'default', color: '#000', fontSize: '0.78rem', marginBottom: 2 }}>
                                                {prefix && <span style={{ fontWeight: 700, marginRight: 4 }}>{prefix}</span>}
                                                {desc}
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        );
                    })()}
                </Popover>
            </>
        );
    }
});